import { render, staticRenderFns } from "./PowerRailInfo.vue?vue&type=template&id=00fdb5c3&scoped=true&"
import script from "./PowerRailInfo.vue?vue&type=script&lang=js&"
export * from "./PowerRailInfo.vue?vue&type=script&lang=js&"
import style0 from "./PowerRailInfo.vue?vue&type=style&index=0&id=00fdb5c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdb5c3",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDataTable,VDialog,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00fdb5c3')) {
      api.createRecord('00fdb5c3', component.options)
    } else {
      api.reload('00fdb5c3', component.options)
    }
    module.hot.accept("./PowerRailInfo.vue?vue&type=template&id=00fdb5c3&scoped=true&", function () {
      api.rerender('00fdb5c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PowerRail/PowerRailInfo.vue"
export default component.exports